import React, { useEffect, useState } from "react";
import DropDown from "../DropDown";

const IndicadoresViewer = ({
  periodos,
  salones,
  periodoId,
  setPeriodoId,
  salonId,
  setSalonId,
  asignaturasDelSalon = [], // ✅ AGREGAR valor por defecto
  indicadoresGuardados,
  setIndicadoresGuardados
}) => {
  const [gradoSeleccionado, setGradoSeleccionado] = useState("");
  const [salonesPreescolar, setSalonesPreescolar] = useState([]);

  const gradosPreescolar = ["parvulos", "prejardin", "jardin", "transicion"];

  // Filtrar salones preescolar
  useEffect(() => {
    const filtrados = salones.filter((s) =>
      gradosPreescolar.includes(
        s.grado?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
      )
    );
    setSalonesPreescolar(filtrados);
  }, [salones]);

  // Obtener grado del salón seleccionado
  useEffect(() => {
    const salon = salones.find((s) => s.id === parseInt(salonId));
    const grado = salon?.grado?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    if (grado) setGradoSeleccionado(grado);
  }, [salonId, salones]);

  const esPreescolar = gradosPreescolar.includes(gradoSeleccionado);

  const mapa = indicadoresGuardados.reduce((acc, item) => {
    acc[item.asignatura_id] = item.descripcion;
    return acc;
  }, {});

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg mt-4">
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <DropDown
          value={salonId}
          onChange={(e) => {
            setSalonId(e.target.value);
            setPeriodoId("");
            setIndicadoresGuardados([]);
          }}
          options={salonesPreescolar.map((s) => ({ value: s.id, label: `${s.nombre} - ${s.grado}` }))}
          placeholder="Seleccione un salón de preescolar"
          className="w-full md:w-1/2"
        />

        <DropDown
          value={periodoId}
          onChange={(e) => setPeriodoId(e.target.value)}
          options={periodos.map((p) => ({ value: p.id, label: p.nombre }))}
          placeholder="Seleccione un periodo"
          className="w-full md:w-1/2"
        />
      </div>

      {!salonId || !periodoId ? (
        <p className="text-center text-gray-600 font-medium">
          Seleccione un salón y un periodo para visualizar los indicadores.
        </p>
      ) : !esPreescolar ? (
        <p className="text-center text-gray-600 font-medium">
          Esta funcionalidad solo está disponible para grados de preescolar (Párvulos, Prejardín, Jardín, Transición).
        </p>
      ) : asignaturasDelSalon.length === 0 ? (
        <p className="text-center text-gray-600 font-medium">
          No hay asignaturas configuradas para este salón.
        </p>
      ) : (
        <table className="w-full border-collapse border border-gray-200 rounded-lg overflow-hidden shadow-md">
          <thead className="bg-blue-900 text-white">
            <tr>
              <th className="px-6 py-3 text-left text-lg font-medium border-b border-gray-200" style={{ width: "46%" }}>
                Asignatura
              </th>
              <th className="px-6 py-3 text-left text-lg font-medium border-b border-gray-200">
                Descripción
              </th>
            </tr>
          </thead>
          <tbody>
            {asignaturasDelSalon.map((asig, index) => (
              <tr key={asig.asignatura_salon_id} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                <td className="px-6 py-4 border-b border-gray-dark font-semibold">{asig.nombre}</td>
                <td className="px-6 py-4 border-b border-gray-dark">
                  <div
                    className="prose max-w-full text-sm text-gray-700"
                    dangerouslySetInnerHTML={{
                      __html: mapa[asig.asignatura_id]?.trim() || "<i>Sin descripción</i>",
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default IndicadoresViewer;